import template from './loansAmountSimulation.html';
import controller from './loansAmountSimulation.controller';
import './loansAmountSimulation.scss';

let loansAmountSimulationComponent = {
  restrict: 'E',
  bindings: {
    hasPrevalidation: '@',
    preValid: '<',
    loan: '<',
    onSubmit: '&',
    simulation: '<',
    housingChange: '<',
    housingLoan: '<',
    onErrorInSelect: '&',
    isMobileApp: '<',
    housingWitness: '<',
    codeOptionSelected: '<',
    simulationWitness:'<',
    initialCharges: '<',
    shouldShowCreditCapacitySimulation: '<',
    isHousingMandatoryPurpose: '<'
  },
  template,
  controller,
};

export default loansAmountSimulationComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loansAmountSimulation/loansAmountSimulation.component.js